import Modal from "../../../../utils/components/Modal";
const UserViewModal = ({ show, hideModal, userInfo }) => {
  return (
    <div>
      <Modal
        title="Personal Information"
        modalSize="xl"
        show={show}
        setShow={hideModal}
      >
        <div className="row mb-4">
          {userInfo &&
            Object.keys(userInfo).map((key) => {
              return (
                <div className="col-12 col-md-6 text-center my-4" key={key}>
                  <p className="mb-1 fs-6">{key}</p>
                  <p className="fw-bold fs-5">{userInfo[key]}</p>
                </div>
              );
            })}
        </div>
      </Modal>
    </div>
  );
};
export default UserViewModal;
